import { computed, Injectable, signal } from '@angular/core';
import { StepInfo } from '../../models/journey-step-tracker/step-info.interface';

@Injectable({ providedIn: 'root' })
export class JourneyStepTrackerService {
  private readonly _stepInfo = signal<StepInfo>({
    currentStep: 1,
    totalSteps: 3,
    title: 'Appliance details',
    isCenterAligned: true,
  });

  readonly stepInfo = this._stepInfo.asReadonly();
  readonly currentStepWithPageName = computed<string>(() => {
    const info = this._stepInfo();
    return `Step ${info.currentStep} of ${info.totalSteps} - ${info.title}`;
  });

  updateStep(
    currentStep: number,
    totalSteps: number,
    title: string,
    isCenterAligned = false,
  ): void {
    this._stepInfo.set({
      currentStep,
      totalSteps,
      title,
      isCenterAligned,
    });
  }

  reset(): void {
    this._stepInfo.set({
      currentStep: 1,
      totalSteps: 3,
      title: 'Appliance details',
      isCenterAligned: true,
    });
  }
}
